export enum ProjectTabValues {
    Basic,
    Lead,
    Products,
    Orders,
    Payments,
}
